// @flow
export const AUTH_SET_SUBSCRIPTIONS = 'auth/SET_SUBSCRIPTIONS';
import type { Subscription } from 'reducers/auth';

export function setSubscriptions(subscriptions: Array<Subscription>) {
  return {
    type: AUTH_SET_SUBSCRIPTIONS,
    subscriptions,
  };
}



// WEBPACK FOOTER //
// ./actions/auth.js